import { render, staticRenderFns } from "./DocumentItemAppend.vue?vue&type=template&id=52900ffc"
import script from "./DocumentItemAppend.vue?vue&type=script&lang=js"
export * from "./DocumentItemAppend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports